module.exports = __webpack_public_path__ + "static/media/4-iron.a20e5b9d.png";